import React from 'react';
import '../../../styles/maintenance/PreventiveMaintenance.css';
import tableData from './dataToday';

const TodayTableShort = ({
  setReadDetails,
  setDetailsID,
  setFormOpen,
  setCreateMaintenanceOpen
}) => {
  const handleDataClick = (id) => {
    setFormOpen(true);
    setReadDetails(true);
    setDetailsID(id);
    setCreateMaintenanceOpen(false);
  };
  return (
    <table className='table-preventive short-tables'>
      <thead className='thead'>
        <tr>
          <th scope='col'></th>
        </tr>
      </thead>
      {tableData.length > 0 ? (
        <tbody>
          {tableData.map((data, id) => {
            return (
              <tr key={id} onClick={() => handleDataClick(id)}>
                <td>{data.title}</td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <p className='loading'>Loading Data...</p>
        </tbody>
      )}
    </table>
  );
};

export default TodayTableShort;
